import { render, staticRenderFns } from "./aside-tests-svg.vue?vue&type=template&id=d85e5214&scoped=true"
import script from "./aside-tests-svg.vue?vue&type=script&lang=js"
export * from "./aside-tests-svg.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d85e5214",
  null
  
)

export default component.exports